import React, {Fragment} from "react"
import { translate } from "react-i18next"
import PropTypes from "prop-types"
import uniqid from "uniqid"
import styled from "styled-components"

function CheckBox({
  labelText, onChangeHandler, t, checked, largeLabel, value, displayInModal, closerCheckboxLabel
}) {
  const CloserLabel = styled.div`
    text-align: right;
    padding-right: 0;
  `

  // Creating a unique identitfier for the checkbox to make sure we don't have clashes.
  const checkboxId = `chk_${uniqid()}_${labelText}`

  // An empty label is set below as that appears to be the only way to get
  // material pro check boxes working with the label on the left.
  return (    
    <div className={displayInModal ? "row" : "row form-group"}>
      {!closerCheckboxLabel && (
        <Fragment>
          <div className={largeLabel ? "col-lg-7 col-md-7" : displayInModal ? "col-lg-9 col-md-9" : "col-lg-5 col-md-5"}>{t(labelText)}</div>
          <div className={largeLabel ? "col-lg-5 col-md-5" : displayInModal ? "col-lg-3 col-md-3" : "col-lg-7 col-md-7"}>
            <input
              type="checkbox"
              id={checkboxId}
              checked={checked}
              className="filled-in"
              onChange={onChangeHandler}
              value={value}
            />
            <label htmlFor={checkboxId}>&nbsp;</label>
          </div>
        </Fragment>
      )}
      {closerCheckboxLabel && (
        <Fragment>
          <div className="col-lg-6 col-md-6">&nbsp;</div>
          <CloserLabel className="col-lg-3 col-md-3">{t(labelText)}</CloserLabel>
          <div className="col-lg-3 col-md-3">
            <input
              type="checkbox"
              id={checkboxId}
              checked={checked}
              className="filled-in"
              onChange={onChangeHandler}
              value={value}
            />
            <label htmlFor={checkboxId}>&nbsp;</label>
          </div>
        </Fragment>
      )}
    </div>
  )
}

CheckBox.propTypes = {
  labelText: PropTypes.string.isRequired,
  onChangeHandler: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  largeLabel: PropTypes.bool,
  value: PropTypes.string,
  displayInModal: PropTypes.bool,
  closerCheckboxLabel: PropTypes.bool,
}

CheckBox.defaultProps = {
  largeLabel: false,
  value: "",
  displayInModal: false,
  closerCheckboxLabel: false
}

export default translate()(CheckBox)



// WEBPACK FOOTER //
// ./src/components/inputs/Checkbox.jsx